import axios from "axios"
import { I18n } from 'react-redux-i18n'

import {getUrlPrefix, getHeaders} from "../helpers/urlHelper"

export function getAppointmentByDate(date) {
  return function(dispatch) {
    dispatch({type: "FETCH_APPOINTMENTS"})

    axios.get(getUrlPrefix() + "/afspraken/getbyday/"+date,
      {
        headers: getHeaders()
      })
        .then((response) => {

        dispatch({type: "FETCH_APPOINTMENTS_FULFILLED", payload: response.data.afspraken})
      })
      .catch((err) => {
        dispatch({type: "FETCH_APPOINTMENTS_REJECTED", payload: err})

        // Show error snackbar
        dispatch({type: "SHOW_SNACKBAR", payload: {
          variant: 'error',
          message: I18n.t('global.server_error'),
          verticalPosition: 'bottom',
          horizontalPosition: 'center',
          duration: 5000
        }})
      })
  }
}

export function getAppointmentById(id){
  return function(dispatch) {
    dispatch({type: "FETCH_APPOINTMENT"})

    axios.get(getUrlPrefix() + "/afspraak/" + id,
      {
        headers: getHeaders()
      })
      .then((response) => {
        dispatch({type: "FETCH_APPOINTMENT_COMPLETE", payload: response.data.afspraak})
      })
      .catch((err) => {
        dispatch({type: "FETCH_APPOINTMENT_REJECTED"})

        if(err.response && err.response.status === 404) {
          // Show error snackbar
          dispatch({type: "SHOW_SNACKBAR", payload: {
            variant: 'error',
            message: err.response.data.message,
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 3000
          }})
        }else{
          // Show error snackbar
          dispatch({type: "SHOW_SNACKBAR", payload: {
            variant: 'error',
            message: I18n.t('global.server_error'),
            verticalPosition: 'bottom',
            horizontalPosition: 'center',
            duration: 5000
          }})
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/js/actions/appointmentActions.js